import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionBullet from "../general/NtSectionBullet";
import { useMobile } from "../../../hooks/useMobile";
import NtText from "../../../components/NtText";

function NtDevopsNeuvectorSection({}) {
  const isMobile = useMobile();

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{ flex: 1, flexDirection: isMobile ? "column-reverse" : "row" }}
      >
        {/* left */}
        <View style={{ flex: 1, justifyContent: "center" }}>
          <NtSectionTitle style={{ textAlign: "left", fontWeight: "300" }}>
            WE CAN HELP YOU{" "}
            <NtText style={{ fontWeight: "900" }}>SECURE YOUR WORKLOADS</NtText>{" "}
            FROM FIRST LINE TO RUNTIME WITH{" "}
            <NtText style={{ fontWeight: "900" }}>
              CLOUD NATIVE RUNTIME SECURITY
            </NtText>
          </NtSectionTitle>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Runtime Visibility with continuous scanning out the container
            lifecycle and network mapping.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Runtime Intrusion Prevention with deep packet inspection to detect
            and block threats.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Exceed Compliance standards with automated audit assessments and
            reporting.
          </NtSectionBullet>
        </View>

        {/* right */}
        <View
          style={{
            flex: isMobile ? 0.5 : 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            style={[
              {
                width: 400,
                height: 400,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/devops-neuvector-logo.png")}
          />
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtDevopsNeuvectorSection;
